import { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "../../../../utils/paypalKeys";
import SpinnerLoading from "../../../shared/spinnerLoading/SpinnerLoading";

const PaypalButtonsInside = ({ fundingSource, onPaypalSubmit }) => {
  const user = useSelector((state) => state.user);
  const order = useSelector((state) => state.order);

  const year = new Date().getFullYear();
  const [{ isPending }] = usePayPalScriptReducer();

  const amount = order.totalCart.toFixed(2);
  const currency = "EUR";
  const style = { layout: "vertical", label: "buynow" };

  const showButtons = order?.totalCart !== null && user.token_id !== null && (
    <PayPalButtons
      style={style}
      disabled={false}
      forceReRender={[amount, currency, style]}
      createOrder={(data, actions) => {
        return actions.order.create({
          purchase_units: [
            {
              reference_id: `${user.token_id}_cart_items`,
              description: `idToken: ${order.orderId}`,
              custom_id: `idOrd: ${year}.${order.orderId}`,
              amount: {
                value: amount,
              },
            },
          ],
          application_context: {
            shipping_preference: "NO_SHIPPING",
          },
        });
      }}
      onApprove={(data, actions) => {
        return actions.order.capture().then(function (details) {
          //alert('Transaction completed by ' + details.payer.name.given_name);
          onPaypalSubmit(details);
        });
      }}
    />
  );

  return (
    <Fragment>
      {isPending ? <SpinnerLoading /> : null}
      {showButtons}
    </Fragment>
  );
};

const PaypalButtons = ({ fundingSource = "paypal", onPaypalSubmit }) => {
  const currentPage = useSelector((state) => state.currentPage);
  const suffissoLang = currentPage.currentLang.replace("_", "");
  useEffect(() => {}, []);

  // opzione configurazione Paypal (passo anche lingua)
  let langPaypal = `${suffissoLang}_${suffissoLang.toUpperCase()}`;
  langPaypal = langPaypal === "en_EN" ? "en_GB" : langPaypal;

  const initialOptions = {
    "client-id": PAYPAL_CLIENT_ID,
    currency: "EUR",
    locale: langPaypal,
    "enable-funding": "paylater",
    "disable-funding": "card,mybank",
    components: "messages,buttons,funding-eligibility",
  };
  return (
    <PayPalScriptProvider options={initialOptions}>
      <PaypalButtonsInside
        fundingSource={fundingSource}
        onPaypalSubmit={onPaypalSubmit}
      />
    </PayPalScriptProvider>
  );
};

export default PaypalButtons;
